/*
 * Copyright (C) 2005 - 2022 TIBCO Software Inc. All rights reserved. Confidentiality & Proprietary.
 * Licensed pursuant to commercial TIBCO End User License Agreement.
 */

export default {
    AD_HOC_DESIGNER: 'adhoc designer',
    JSS_IREPORT_STUDIO: 'JSS/iReport studio'
};